import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { GetPessoaJuridicaCnpjService } from '@/features/proposta/services/get-pessoa-juridica-por-cnpj'
import { propostaKeys } from '@/features/proposta/utils'
import type { TConta } from '@/shared/interfaces/conta.types'

export const usePessoaJuridicaPorCnpj = (cnpj: string, enabled?: boolean): UseQueryResult<TConta, AxiosError> => {
  return useQuery({
    queryKey: propostaKeys.pessoaJuridica(cnpj),
    queryFn: async () => new GetPessoaJuridicaCnpjService().execute({ cnpj }).then((res) => res.data),
    enabled,
  })
}
